import { t } from "../services/utils";
export default {
  NOT_LOADED: 1,
  LOADING: 2,
  LOADED: 3,
  ERROR: 4
};